import { render, staticRenderFns } from "./BodyguardServiceForm.vue?vue&type=template&id=8f05ac72&scoped=true"
import script from "./BodyguardServiceForm.vue?vue&type=script&lang=js"
export * from "./BodyguardServiceForm.vue?vue&type=script&lang=js"
import style0 from "./BodyguardServiceForm.vue?vue&type=style&index=0&id=8f05ac72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f05ac72",
  null
  
)

export default component.exports